(() => {
  const qs = (s,c=document)=>c.querySelector(s);
  const qsa = (s,c=document)=>[...c.querySelectorAll(s)];
  const root = window.Shopify?.routes?.root || '/';

  function trapFocus(container){
    const focusable=qsa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])',container).filter(el=>!el.disabled);
    if(!focusable.length)return()=>{};
    const first=focusable[0],last=focusable[focusable.length-1];
    const handler=e=>{
      if(e.key==='Escape'){container.hidden=true;return;}
      if(e.key!=='Tab')return;
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    };
    container.addEventListener('keydown',handler);first.focus();
    return()=>container.removeEventListener('keydown',handler);
  }

  async function fetchCart(){
    const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
    if(!r.ok)throw new Error('Unable to load your bag.');
    return r.json();
  }

  function money(cents){
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(cents/100);
  }

  async function renderCart(){
    const cart=await fetchCart();
    qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    qsa('[data-cart-subtotal]').forEach(el=>el.textContent=money(cart.total_price));
    const container=qs('[data-cart-items]');
    if(container){
      container.innerHTML=cart.items.map(item=>{
        const variant=item.variant_title&&item.variant_title!=='Default Title'?`<p class="v2-cline__variant">${item.variant_title}</p>`:'';
        return `
        <article class="v2-cline" data-key="${item.key}">
          <a class="v2-cline__imgwrap" href="${item.url}"><img class="v2-cline__img" src="${item.image||''}" alt="" loading="lazy"></a>
          <div class="v2-cline__info">
            <a class="v2-cline__title" href="${item.url}">${item.product_title}</a>
            ${variant}
            <div class="v2-cline__row">
              <div class="v2-cline__qty">
                <button type="button" data-cart-dec="${item.key}" aria-label="Decrease quantity">&minus;</button>
                <input type="text" inputmode="numeric" value="${item.quantity}" data-cart-quantity="${item.key}" aria-label="Quantity" readonly>
                <button type="button" data-cart-inc="${item.key}" aria-label="Increase quantity">+</button>
              </div>
              <span class="v2-cline__price">${money(item.final_line_price)}</span>
            </div>
            <button type="button" class="v2-cline__remove" data-cart-remove="${item.key}">Remove</button>
          </div>
        </article>`;}).join('')||'<p class="v2-cart__empty">Your bag is empty.</p>';
    }
    const drawer=qs('[data-cart-drawer]'); if(drawer)drawer.classList.toggle('is-empty',cart.item_count===0);
    return cart;
  }

  async function addItems(items){
    const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await r.json();
    if(!r.ok)throw new Error(data.description||'Unable to add item.');
    await renderCart();
    const drawer=qs('[data-cart-drawer]'); if(drawer){drawer.hidden=false;trapFocus(drawer);}
    const live=qs('[data-cart-live]'); if(live)live.textContent='Added to your bag.';
  }

  document.addEventListener('submit',async e=>{
    const form=e.target.closest('form[action*="/cart/add"]'); if(!form)return;
    e.preventDefault(); const btn=qs('[type="submit"]',form),status=qs('.form-status',form);
    btn?.setAttribute('aria-busy','true');
    try{const fd=new FormData(form);await addItems([{id:Number(fd.get('id')),quantity:Number(fd.get('quantity')||1)}]);if(status)status.textContent='Added to your bag.';}
    catch(err){if(status)status.textContent=err.message;}
    finally{btn?.removeAttribute('aria-busy');}
  });

  document.addEventListener('click',async e=>{
    const open=e.target.closest('[data-cart-open]'); if(open){await renderCart();const d=qs('[data-cart-drawer]');d.hidden=false;trapFocus(d);}
    const close=e.target.closest('[data-cart-close]'); if(close)qs('[data-cart-drawer]').hidden=true;
    const remove=e.target.closest('[data-cart-remove]'); if(remove){await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})});await renderCart();}
    const dec=e.target.closest('[data-cart-dec]'); if(dec){const inp=dec.parentElement.querySelector('[data-cart-quantity]');const q=Math.max(0,Number(inp.value)-1);await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:dec.dataset.cartDec,quantity:q})});await renderCart();}
    const inc=e.target.closest('[data-cart-inc]'); if(inc){const inp=inc.parentElement.querySelector('[data-cart-quantity]');const q=Number(inp.value)+1;await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:inc.dataset.cartInc,quantity:q})});await renderCart();}
    const menu=e.target.closest('[data-mobile-open]'); if(menu){const d=qs('[data-mobile-drawer]');d.hidden=false;trapFocus(d);}
    const menuClose=e.target.closest('[data-mobile-close]'); if(menuClose)qs('[data-mobile-drawer]').hidden=true;
    const search=e.target.closest('[data-search-open]'); if(search){const d=qs('[data-search-drawer]');d.hidden=false;trapFocus(d);}
    const searchClose=e.target.closest('[data-search-close]'); if(searchClose)qs('[data-search-drawer]').hidden=true;
    const bundleAdd=e.target.closest('[data-bundle-add]');
    if(bundleAdd){
      e.preventDefault();
      const id=bundleAdd.dataset.bundleId||'sclptiq-bundle';
      const one=Number(bundleAdd.dataset.variantOne),two=Number(bundleAdd.dataset.variantTwo);
      const st=bundleAdd.closest('section')?.querySelector('[data-bundle-status]');
      bundleAdd.setAttribute('aria-busy','true');
      try{await addItems([{id:one,quantity:1,properties:{'_bundle_id':id,'_bundle_tier':'2'}},{id:two,quantity:1,properties:{'_bundle_id':id,'_bundle_tier':'2'}}]);if(st)st.textContent='Added to your bag.';}
      catch(err){if(st)st.textContent=err.message;}
      finally{bundleAdd.removeAttribute('aria-busy');}
    }
  });

  document.addEventListener('change',async e=>{
    const input=e.target.closest('[data-cart-quantity]'); if(input){await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:input.dataset.cartQuantity,quantity:Number(input.value)})});await renderCart();}
    const slider=e.target.closest('[data-ba-range]'); if(slider){const wrap=slider.closest('[data-ba]');qs('.ba-slider__after',wrap).style.clipPath=`inset(0 ${100-slider.value}% 0 0)`;qs('.ba-slider__handle',wrap).style.left=slider.value+'%';}
  });

  qsa('[data-quantity-bundles]').forEach(section=>{
    const radios=qsa('[data-tier-radio]',section),status=qs('[data-tier-status]',section),btn=qs('[data-tier-add]',section);
    let tier=1,cream=1,stick=0;
    const render=()=>{qs('[data-cream-count]',section).textContent=cream;qs('[data-stick-count]',section).textContent=stick;btn.disabled=(cream+stick)!==tier;status.textContent=btn.disabled?`Choose exactly ${tier} product${tier>1?'s':''}.`:'';};
    radios.forEach(r=>r.addEventListener('change',()=>{tier=Number(r.value);cream=tier;stick=0;render();}));
    section.addEventListener('click',e=>{
      if(e.target.matches('[data-cream-plus]')&&cream+stick<tier)cream++;
      if(e.target.matches('[data-stick-plus]')&&cream+stick<tier)stick++;
      if(e.target.matches('[data-cream-minus]')&&cream>0)cream--;
      if(e.target.matches('[data-stick-minus]')&&stick>0)stick--;
      if(e.target.matches('[data-cream-plus],[data-stick-plus],[data-cream-minus],[data-stick-minus]'))render();
    });
    let bundleMap={};
    try{bundleMap=JSON.parse(btn.dataset.bundleVariants||'{}');}catch(e){}
    btn?.addEventListener('click',async()=>{
      const key=`${tier}:${cream}:${stick}`;
      const variantId=bundleMap[key];
      if(!variantId){status.textContent='Please choose your combination.';return;}
      btn.disabled=true;
      try{await addItems([{id:Number(variantId),quantity:1}]);status.textContent='Added to your bag.';}catch(err){status.textContent=err.message;}finally{render();}
    });
    render();
  });

  // UGC: muted autoplay only while in viewport (respects reduced motion)
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ugcVideos = qsa('.video-rail video');
  if (ugcVideos.length && 'IntersectionObserver' in window && !reduceMotion){
    const io = new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        const v = entry.target;
        if(entry.isIntersecting){ v.muted=true; const p=v.play(); if(p&&p.catch)p.catch(()=>{}); }
        else { v.pause(); }
      });
    }, {threshold:0.6});
    ugcVideos.forEach(v=>io.observe(v));
  }

  // Predictive search
  const psInput = qs('[data-predictive-input]');
  const psResults = qs('[data-predictive-results]');
  if (psInput && psResults){
    let psTimer;
    const renderResults = (data)=>{
      const products = (data?.resources?.results?.products)||[];
      if(!products.length){ psResults.innerHTML = psInput.value.trim() ? '<p class="predictive-empty">No results yet.</p>' : ''; return; }
      psResults.innerHTML = '<ul class="predictive-list">' + products.map(p=>`
        <li><a href="${p.url}">
          ${p.featured_image&&p.featured_image.url?`<img src="${p.featured_image.url}" alt="" width="48" height="48" loading="lazy">`:''}
          <span>${p.title}</span>
        </a></li>`).join('') + '</ul>';
    };
    psInput.addEventListener('input', ()=>{
      const q = psInput.value.trim();
      clearTimeout(psTimer);
      if(q.length<2){ psResults.innerHTML=''; return; }
      psTimer = setTimeout(async ()=>{
        try{
          const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const r = await fetch(url,{headers:{Accept:'application/json'}});
          if(!r.ok) return;
          renderResults(await r.json());
        }catch(e){ /* silent */ }
      }, 220);
    });
  }
})();
